import { cloneDeep } from 'lodash';
import SupplierTodoType from './SupplierToDo.type';
import { setArrayByCase, Page_Size } from '../../../../../Components/helper';

const initialState = {
  supplierConfigData: null,
  supplierTodoList: [],
  supplierTodoTotalCount: 0,
  currentRequestId: null,
  supplierToDoSelectedIds: [],
  supplierFilterValues: {
    selected_Season: [],
    selected_Brand: [],
    selected_Supplier: [],
    selected_Category1: [],
    selected_Category2: [],
    selected_Category3: [],
    selected_Category4: [],
    selected_Status: null,
    selected_Section: null,
    selectedBomFields: null,
    selectedLicensor: [],
    selectedLicense: [],
    selectedLikeness: [],
    searchText: '',
    pageIndex: 1,
    pageSize: Page_Size,
    sortOrder: '',
    sortPropertyName: '',
    loading: false,
    showOnly: null,
  },
  toDoDetailData: [],
  sectionOptions: [{ value: 'BOM', label: 'Bill of Materials' }],
  componentSubType: [],
};

const SupplierTodoReducer = (state = initialState, action) => {
  switch (action.type) {
    case SupplierTodoType.SET_SUPPLIER_CONFIG_DATA:
      return {
        ...state,
        supplierConfigData: action.payload,
      };
    case SupplierTodoType.SET_SUPPLIER_DETAIL_DATA:
      return {
        ...state,
        toDoDetailData: action.payload,
      };
    case SupplierTodoType.SET_SUPPLIER_REQUESTS_TODOLIST: {
      if (
        action.payload.requestId &&
        state.currentRequestId &&
        Number(action.payload.requestId) < Number(state.currentRequestId)
      ) {
        return state;
      }
      const updatedArry = cloneDeep(setArrayByCase(state.supplierTodoList, action.payload));
      return {
        ...state,
        supplierTodoList: updatedArry,
        supplierTodoTotalCount: action.payload.totalCount,
        currentRequestId: action.payload.requestId || state.currentRequestId,
      };
    }
    case SupplierTodoType.SET_SUPPLIER_FILTER_SORT_DATA:
      return {
        ...state,
        supplierFilterValues: {
          ...state.supplierFilterValues,
          ...action.payload,
        },
      };
    case SupplierTodoType.GET_COMPONENT_TYPE:
      return {
        ...state,
        componentSubType: action.payload,
      };
    default:
      return state;
  }
};

export default SupplierTodoReducer;
